<div *ngIf="varietyList && total">
  <h2>LISTA DE VARIEDADES ({{ total }} )</h2>
  <h4>Detalle: 300 dpi</h4>
  <h4>Resolucion (pixeles): 300x300</h4>
  <div fxLayout="row wrap" fxLayoutAlign="space-around center">
    <div
      fxFlex="30"
      style="
        border: solid 1px #adadad;
        border-radius: 10px;
        padding: 5px;
        margin: 5px;
      "
      *ngFor="let variety of varietyList; let i = index"
    >
      <!-- ==================================== -->

      <div *ngIf="variety.genotype_data">
        <h3>{{ variety.variety_name }}</h3>
        <div style="justify-content: center; display: flex">
          <qrcode
            [qrdata]="
              'https://wikipapa.org/pages/report/index.php?id=' +
              variety.variety_id
            "
            [width]="300"
            [errorCorrectionLevel]="'M'"
          ></qrcode>
        </div>

        <a
          [href]="
            'https://wikipapa.org/pages/report/index.php?id=' +
            variety.variety_id
          "
        >
          ir a la vista</a
        >
      </div>

      <!-- ==================================== -->
    </div>
  </div>
</div>
